'use strict';

import React from 'react';
import { PlayLogo } from './PlayLogo.styles';
import MenuItem from '../MenuItem/MenuItem';
import { ListItem } from '../MenuItem/MenuItem.styles';
import AutoCompleteSearchFormContainer from '../../AutoCompleteSearch/AutoCompleteSearchFormContainer.jsx';
import { Navigation, LogoText, MenuItems, SearchLink, SearchListItem } from './Menu.styles.js';
import PlayText, { TYPES } from '../../../../ui-components/typography/PlayText/PlayText';

export const Menu = (props) => (
    <Navigation aria-label="topp-navigation" data-rt="play-navigation">
        <PlayLogo to="/" tabIndex="-1" regTestSpec="play-logo">
            <LogoText>SVT Play</LogoText>
        </PlayLogo>
        <MenuItems>
            <MenuItem route="/" accessKey="1" text="Start" type="start" isIndexLink={true} index={1} />
            <MenuItem route="/program" accessKey="2" text="Program" type="programs" index={2} />
            <MenuItem route="/kanaler" accessKey="3" text="Kanaler" type="channels" index={3} />
            <ListItem type="search">
                <SearchLink href="/sok" onClick={props.toogleMenuSearchInputVisibility}>
                    <PlayText as="span" type={TYPES.SMALL}>
                        Sök
                    </PlayText>
                </SearchLink>
            </ListItem>
            <SearchListItem hiddenXs={!props.searchInputActiveOnMobile}>
                <AutoCompleteSearchFormContainer {...props} />
            </SearchListItem>
        </MenuItems>
    </Navigation>
);

export default Menu;
